import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import type { NoteSummary } from "@/api/types";
import { timeAgo, cn } from "@/lib/utils";
import { ClientBadge } from "./ClientBadge";

export function NoteRow({ note, showSnippet = true, className }: { note: NoteSummary; showSnippet?: boolean; className?: string }) {
  return (
    <Link
      to={`/notes/${note.id}`}
      className={cn(
        "group flex items-start gap-3 rounded-lg px-3 py-2.5 transition-colors hover:bg-muted/60 focus-visible:bg-muted/60 focus-visible:outline-none",
        className,
      )}
    >
      <FileText className="mt-1 size-4 shrink-0 text-muted-foreground" aria-hidden />
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-3">
          <span className="truncate text-[0.95rem] font-medium">{note.title || "Untitled"}</span>
          <span className="shrink-0 text-xs text-muted-foreground" title={note.updatedAt}>
            {timeAgo(note.updatedAt)}
          </span>
        </div>
        {showSnippet && note.snippet && (
          <p className="mt-0.5 line-clamp-2 text-sm text-muted-foreground">{note.snippet}</p>
        )}
        <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
          <ClientBadge client={note.updatedByClient} />
          <span>v{note.version}</span>
        </div>
      </div>
    </Link>
  );
}
